import { Alert, AlertIcon, Button, HStack, Icon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiExternalLink } from "react-icons/fi";
import { Link as RouterLink } from "react-router-dom";
import type { MarketDialogueRoundDto } from "../../autogen/bff-api";
import { urls } from "../../urls";

export const CommentRoundNotice = ({ round, dialogueId }: { round: MarketDialogueRoundDto; dialogueId: string }) => {
  const { t } = useTranslation();
  if (!round.procurementId && round.number === 1) return null;
  const showsFirstRound = round.firstRoundId !== dialogueId;

  return (
    <Alert status="info" borderRadius="md" mt="4" alignItems="flex-start" data-testid="comment-round-notice">
      <AlertIcon />
      <Stack spacing="2" flex="1" minW="0" fontSize="sm">
        <Text>
          {round.procurementId
            ? t(
                "Round {{number}} of the market dialogue sends the draft procurement out for comment. The items below are the version that was sent, and the procurement stays editable while the round is open.",
                { number: round.number },
              )
            : t("Round {{number}} of the market dialogue.", { number: round.number })}
        </Text>
        <HStack spacing="4" wrap="wrap">
          {round.procurementId && (
            <Button
              as={RouterLink}
              to={urls.app.sourcingEvents.view.go(round.procurementId)}
              target="_blank"
              variant="link"
              size="sm"
              alignSelf="flex-start"
              colorScheme="teal"
              rightIcon={<Icon as={FiExternalLink} />}
            >
              {t("Open the procurement")}
            </Button>
          )}
          {showsFirstRound && (
            <Button
              as={RouterLink}
              to={urls.app.marketDialogues.view.go(round.firstRoundId)}
              target="_blank"
              variant="link"
              size="sm"
              alignSelf="flex-start"
              colorScheme="teal"
              rightIcon={<Icon as={FiExternalLink} />}
            >
              {t("Open the first round")}
            </Button>
          )}
        </HStack>
      </Stack>
    </Alert>
  );
};
